// src/context/NotificationContext.jsx
import { createContext, useContext, useEffect, useState } from "react";
import { DeleteNotification } from "../services/Notification/NotificationApi";

const NotificationContext = createContext();
export const useNotifications = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
    const [notificationCount, setNotificationCount] = useState(2)
    const [notifications, setNotifications] = useState([]);

    const [selectedNotification, setSelectedNotification] = useState(null);
    const [isNotificationUpdate, setIsNotificationUpdate] = useState(false);



    const deleteNotification = async (value) => {

        try {
            const response = await DeleteNotification(value?.notificationKeyID);
            if (response.data?.statusCode === 200) {
                const list = response.data?.responseData?.data || [];
                setIsNotificationUpdate(true)
            }
        } catch (error) {
            console.log(error);
        }
    };

    const markAllRead = () => {
        setNotifications((prev) => prev.map((n) => ({ ...n, unread: false })));
    };

    return (
        <NotificationContext.Provider
            value={{
                notifications,
                setNotifications,
                isNotificationUpdate,
                setIsNotificationUpdate,
                markAllRead,
                deleteNotification,
                selectedNotification,
                setSelectedNotification,
                setNotificationCount,
                notificationCount
            }}
        >
            {children}
        </NotificationContext.Provider>
    );
};
